import { Component, type ErrorInfo, type ReactNode } from "react";

type ErrorBoundaryProps = Readonly<{ children: ReactNode }>;
type ErrorBoundaryState = Readonly<{ failed: boolean }>;

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(
      JSON.stringify({
        event: "client_route_failed",
        error: error.name,
        componentStack: info.componentStack,
      }),
    );
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="assessment-page assessment-page--status">
          <h1>表示に失敗しました</h1>
          <p>結果や回答を勝手に送信せず、安全に診断を再開できます。</p>
          <a href="/check">診断を最初から始める</a>
        </main>
      );
    }

    return this.props.children;
  }
}
